if (!customElements.get('ns-club-journey')) {
  customElements.define('ns-club-journey', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.goal = Math.max(2, Number(this.dataset.goal) || 5);
      this.stamps = [...this.querySelectorAll('[data-ns-club-stamps] li')];
      this.control = this.querySelector('[data-journey-control]');
      this.elapsed = 0;
      this.visible = false;
      this.userPaused = false;
      this.completed = false;
      this.frame = null;
      this.previousTime = null;
      this.scene = -1;
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .35;
        if (this.visible) this.classList.add('is-in-view');
        this.syncPlayback();
      }, { threshold: .35 });
      this.control.addEventListener('click', () => {
        if (this.completed) {
          this.elapsed = 0;
          this.completed = false;
          this.userPaused = false;
          this.setProgress(0, true);
          this.setScene(0);
        } else {
          this.userPaused = !this.userPaused;
        }
        this.syncPlayback();
      }, options);
      this.motion.addEventListener('change', () => this.syncState(), options);
      document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
      document.addEventListener('ns:club-ready', () => this.syncState(), options);
      this.syncState();
      this.observer.observe(this);
    }
    syncState() {
      const state = window.NSClubAPI?.state;
      const guest = state ? !state.logged : this.dataset.guest === 'true';
      this.guest = guest;
      this.dataset.guest = String(guest);
      this.toggleAttribute('data-reduced', this.motion.matches);
      this.querySelectorAll('[data-journey-example]').forEach(node => { node.hidden = !guest; });
      this.querySelector('[data-journey-account]').hidden = guest;
      this.querySelector('[data-journey-demo-balance]').hidden = !guest;
      this.querySelector('[data-ns-club-balance]').hidden = guest;
      this.querySelector('[data-ns-club-status]').hidden = guest;
      this.control.hidden = !guest || this.motion.matches;
      if (!guest) {
        this.stopFrame();
        const pending = state ? state.balanceReady === false : this.dataset.pending === 'true';
        this.toggleAttribute('data-pending', pending);
        const shown = state ? state.shown : Number(this.dataset.shown) || 0;
        this.setProgress(pending ? 0 : Math.min(this.goal, Math.max(0, shown)), false);
        return;
      }
      this.removeAttribute('data-pending');
      if (this.motion.matches) {
        this.stopFrame();
        this.completed = true;
        this.setProgress(this.goal, true);
        this.setScene(2);
        return;
      }
      if (this.hasAttribute('data-was-reduced')) {
        this.elapsed = 0;
        this.completed = false;
        this.userPaused = false;
        this.removeAttribute('data-was-reduced');
      }
      this.setProgress(this.completed ? this.goal : 0, true);
      this.setScene(this.completed ? 2 : 0);
      this.syncPlayback();
    }
    syncPlayback() {
      const running = this.guest && !this.motion.matches && this.visible && !document.hidden && !this.userPaused && !this.completed;
      const mode = this.completed ? 'replay' : running ? 'pause' : 'resume';
      this.dataset.playState = running ? 'running' : this.completed ? 'complete' : 'paused';
      this.control.setAttribute('aria-label', this.dataset[mode + 'Label']);
      this.querySelector('[data-journey-control-label]').textContent = this.dataset[mode];
      this.querySelectorAll('[data-journey-icon]').forEach(icon => { icon.toggleAttribute('hidden', icon.dataset.journeyIcon !== mode); });
      if (!running) {
        this.stopFrame();
        return;
      }
      if (this.frame === null) this.frame = requestAnimationFrame(time => this.tick(time));
    }
    tick(time) {
      this.frame = null;
      if (this.previousTime !== null) this.elapsed += Math.min(time - this.previousTime, 100);
      this.previousTime = time;
      const amount = Math.min(1, Math.max(0, (this.elapsed - 600) / 4200));
      this.setProgress(amount * this.goal, true);
      this.setScene(this.elapsed < 1600 ? 0 : this.elapsed < 3400 ? 1 : 2);
      if (this.elapsed >= 6500) {
        this.completed = true;
        this.syncPlayback();
      } else {
        this.frame = requestAnimationFrame(next => this.tick(next));
      }
    }
    setProgress(amount, demo) {
      const count = Math.min(this.goal, Math.floor(amount + .0001));
      const progress = Math.max(0, Math.min(1, (amount - 1) / (this.goal - 1)));
      this.style.setProperty('--journey-progress', progress.toFixed(4));
      this.toggleAttribute('data-reward-ready', count === this.goal);
      this.stamps.forEach((stamp, index) => {
        stamp.style.setProperty('--stamp-fill', demo ? Math.min(1, Math.max(0, amount - index)).toFixed(4) : index < count ? '1' : '0');
        stamp.classList.toggle('is-demo-filled', demo && index < count);
      });
      if (demo) {
        const counter = this.querySelector('[data-journey-count]');
        if (counter.textContent !== String(count)) counter.textContent = count;
      }
    }
    setScene(index) {
      if (this.scene === index) return;
      this.scene = index;
      this.querySelectorAll('[data-journey-scene]').forEach((scene, i) => { scene.hidden = i !== index; });
    }
    stopFrame() {
      if (this.frame !== null) cancelAnimationFrame(this.frame);
      this.frame = null;
      this.previousTime = null;
      if (this.motion.matches) this.setAttribute('data-was-reduced', '');
    }
    disconnectedCallback() {
      this.stopFrame();
      this.observer?.disconnect();
      this.abort?.abort();
      this.abort = null;
    }
  });
}
